import styled from 'styled-components';

export const DynamicDashboardStyled = styled.div`

.slick-slider .slick-track{
    display: flex !important;
}
`;
